import React, { useContext } from 'react';
import { string, bool } from 'prop-types';

import {
  extend,
  params,
  string as stringType,
  shape as shapeType,
  arrayOf as arrayType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Row, Col } from '@thd-olt-component-react/core-ui';
import { RentalPrice } from '@thd-olt-component-react/rental-price';
import { ProductInfoBar } from '@thd-olt-component-react/product-info-bar';

import { Header } from '../../components/header/header';
import { BrowseCallout } from '../../components/browse-callout/browse-callout';
import helper from '../../utils/helper';

import './product-information.scss';

export const ProductInformation = ({ itemId, pricingGraphQlEnabled, isDeliveryFlow, isRentalClearTool }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = (channel === 'mobile');

  const { data: productData } = useDataModel('product', { variables: { itemId } });
  const { brandName, canonicalUrl, productLabel, rentalCategory } = productData?.product?.identifiers || '';
  const { url } = productData?.product?.media?.image || '';
  const isAVehicle = helper.vehicleCheck(rentalCategory);

  return (
    <Row className="left-card card-shadow" data-component="ProductInformation">
      <Row>
        { isMobile && <Col><Header canonicalUrl={canonicalUrl} /></Col> }
        <Col className="product-info-bar">
          <ProductInfoBar itemId={itemId} />
        </Col>
        { isMobile && (
          <Col data-testid="mobile-media-wrapper" className="media-wrapper" fallback="4" xs="6">
            <img
              src={url}
              alt={productLabel}
              height="100px"
              width="100px"
            />
          </Col>
        ) }
        <Col fallback="8" xs="6" lg="12">
          <span><h2 className="brand-name"><b>{brandName}</b></h2></span>
          <span className="u__paddingTop u__paddingBottom"><h2>{productLabel}</h2></span>
        </Col>
        <Col>
          <div className="u__paddingBottom">Accessories fees may apply.</div>
          <RentalPrice
            itemId={itemId}
            graphQlEnabled={pricingGraphQlEnabled}
            hideStoreInfo
            depositCalloutReduced
            isDeliveryFlow={isDeliveryFlow}
            isRentalClearTool={isRentalClearTool}
          />
        </Col>
        { isMobile && (
          <Col>
            <BrowseCallout isAVehicle={isAVehicle} isDelivery={isDeliveryFlow} />
          </Col>
        )}
      </Row>
      { !isMobile && (
        <Col data-testid="desktop-media-wrapper" className="media-wrapper">
          <img
            src={url}
            alt={productLabel}
            height="600px"
            width="600px"
          />
        </Col>
      ) }
    </Row>
  );
};

ProductInformation.propTypes = {
  itemId: string.isRequired,
  pricingGraphQlEnabled: bool,
  isDeliveryFlow: bool,
  isRentalClearTool: bool
};

ProductInformation.defaultProps = {
  pricingGraphQlEnabled: false,
  isDeliveryFlow: false,
  isRentalClearTool: false
};

ProductInformation.dataModel = extend(
  {
    product: params({ itemId: stringType().isRequired(), dataSource: stringType() }).shape({
      itemId: stringType(),
      dataSources: stringType(),
      identifiers: shapeType({
        brandName: stringType(),
        productLabel: stringType(),
        rentalCategory: stringType(),
        rentalSubCategory: stringType(),
        itemId: stringType()
      }),
      media: shapeType({
        image: shapeType({
          url: stringType()
        }).client(),
        images: arrayType(shapeType({
          sizes: arrayType(stringType()),
          subType: stringType(),
          type: stringType(),
          url: stringType()
        }))
      })
    })
  },
  ProductInfoBar,
  RentalPrice
);
